export type STATUS_TYPE = 'idle' | 'pending' | 'succeeded' | 'failed';


export type IParams = {
  id: string;
};

export enum Language {
  english = "en",
  arabic = "ar",
}

export enum DocumentType {
  UserProfile = "userprofile",
  category = "category",
  Shape = "shape", // Shape preview image
  ShapeTop = "shape_top",
  ShapeFront = "shape_front",
  ShapeSliced = "shape_sliced",
  ShapeColorTop = "shape_color_top",
  ShapeColorFront = "shape_color_front",
  ShapeColorSliced = "shape_color_sliced",
  Flavor = "flavor", // Flavor preview image
  FlavorShapeTop = "flavor_shape_top",
  FlavorShapeFront = "flavor_shape_front",
  FlavorShapeSliced = "flavor_shape_sliced",
  Topping = "topping", // Topping preview image
  ToppingCategory = "topping_category",
  ToppingShapeTop = "topping_shape_top",
  ToppingShapeFront = "topping_shape_front",
  ToppingShapeSlice = "topping_shape_slice",
  AddonCategory = "addon_category",
  AddonVariant = "addon_variant",
  Slider = "slider",
  AddonProduct = "addon_product",
  CakePrint = "cake_print", // Custom cake print image
  CakeBox = "cake_box",
  ServiceCategory = "service_category",
  ServiceProduct = "service_product",
}


export enum DisplayMode {
  front = "front",
  top = "top",
}

export enum PaymentMethod {
  refund = "refund",
}

export enum OrderStatus {
  pending = "pending",
  confirmed = "confirmed",
  shipped = "shipped",
  delivered = "delivered",
  cancelled = "cancelled",
}

export enum TimePeriod {
  today = "today",
  yesterDay = "yesterday",
  lastSevenDays = "lastSevenDays",
  lastThirtyDays = "lastThirtyDays",
  lastSixMonths = "lastSixMonths",
  currentYear = "currentYear",
  lastOneYear = "lastOneYear",
  customRange = "customRange",
}

export enum PushNotificationType {
  category = "category",
  address = "address",
  orderAmount = "orderAmount",
  orderCount = "orderCount",
  language = "language",
  allUsers = "allUsers",
  allDownloadedUsers = "allDownloadedUsers"
}


export enum ActionType {
  makeACake = "make-a-cake",
  occasionCategory = "occasion-category",
  occasionCake = "occasion-cake",
  noAction = "no-action",
  reward = "reward",
  flower = "flower",
  eventService = "event-service",
}

export enum ContactFormType {
  messageToChef = "message-to-chef"
}


export enum EnglishSettingsFAQ {
  id = "e96c3c89-0092-470b-bd9c-14fc05ad3662",
  name = "faq",
  valueType = "json",
}

export enum ArabicSettingsFAQ {
  id = "c83face8-6ca8-4434-a575-b26737c0bae7",
  name = "faq",
  valueType = "json",
}

export enum NotificationModuleType {
  address = "address",
  order = "order",
  category = "category",
}